import LBHItineraryMap from './mapModules/LBHItineraryMap.js';

document.addEventListener( 'DOMContentLoaded', () => {
	if ( ! window.lbhMapConfig || ! window.lbhItineraries ) return;
	const canvas = document.getElementById( 'lbh-map-canvas' );
	if ( ! canvas ) return;

	const params             = new URLSearchParams( window.location.search );
	const initialItineraryId = params.get( 'itinerary_id' ) ? parseInt( params.get( 'itinerary_id' ), 10 ) : null;
	const location           = params.get( 'location' ) || window.lbhMapConfig.location || '';
	const initialLat         = params.get( 'lat' )  ? parseFloat( params.get( 'lat' ) )  : null;
	const initialLng         = params.get( 'lng' )  ? parseFloat( params.get( 'lng' ) )  : null;
	const initialZoom        = params.get( 'zoom' ) ? parseFloat( params.get( 'zoom' ) ) : null;
	const initialHasPromo    = params.get( 'offers' ) === 'on';

	const lbhMap = new LBHItineraryMap( {
		container:           'lbh-map-canvas',
		accessToken:         window.lbhMapConfig.accessToken,
		style:               window.lbhMapConfig.style,
		itineraries:         window.lbhItineraries,
		hotels:              window.lbhAccommodations || [],
		apiBase:             window.lbhMapConfig.apiBase,
		lang:                window.lbhMapConfig.lang,
		location,
		initialItineraryId,
		initialMode:         window.lbhMapConfig.initialMode || 'itineraries',
		initialLat,
		initialLng,
		initialZoom,
		initialHasPromo,
	} );

	lbhMap.init();

	document.getElementById( 'sidebar-close' )?.addEventListener( 'click', () => {
		lbhMap.resetMap();
	} );

	// ── Mobile sidebar toggle ─────────────────────────────────────────────
	const sidebar = document.getElementById( 'map-sidebar' );
	const handle  = document.getElementById( 'sidebar-mobile-handle' );

	const isMobile = () => window.innerWidth <= 768;

	if ( sidebar && handle ) {
		const TRANSITION_MS = 310; // slightly past the 0.3s CSS transition

		const toggleSidebar = () => {
			if ( ! isMobile() ) return;
			const willCollapse = ! sidebar.classList.contains( 'is-collapsed' );
			sidebar.classList.toggle( 'is-collapsed', willCollapse );
			handle.setAttribute( 'aria-expanded', String( ! willCollapse ) );
			handle.setAttribute( 'aria-label', willCollapse ? 'Apri filtri' : 'Chiudi filtri' );

			// Update Mapbox bottom-padding once the CSS transition finishes
			setTimeout( () => {
				if ( lbhMap && lbhMap.map ) {
					lbhMap.map.setPadding( lbhMap._getSidebarPadding() );
				}
			}, TRANSITION_MS );
		};

		handle.addEventListener( 'click', toggleSidebar );
		handle.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Enter' || e.key === ' ' ) {
				e.preventDefault();
				toggleSidebar();
			}
		} );

		// On desktop: clear mobile class if viewport grows past breakpoint
		window.addEventListener( 'resize', () => {
			if ( ! isMobile() ) {
				sidebar.classList.remove( 'is-collapsed' );
			}
		}, { passive: true } );
	}
} );
